import type { AppState } from '../types';
import type { HubState } from './types';

export const getHubBackendEnvironmentUrl = (
  state: AppState,
): HubState['hubBackendEnvironmentUrl'] => state.hub.hubBackendEnvironmentUrl;

export const getIsLaunchOnStartup = (state: AppState): HubState['isLaunchOnStartup'] =>
  state.hub.isLaunchOnStartup;

export const getIsAutoUpdatesEnabled = (state: AppState): HubState['isAutoUpdatesEnabled'] =>
  state.hub.isAutoUpdatesEnabled;

export const getCashDrawerCable = (state: AppState): HubState['cashDrawerCable'] =>
  state.hub.cashDrawerCable;

export const getEnabledLoggerScopes = (state: AppState): HubState['enabledLoggerScopes'] =>
  state.hub.enabledLoggerScopes;

export const getAllowNotifications = (state: AppState): HubState['allowNotifications'] =>
  state.hub.allowNotifications;

export const getLanguage = (state: AppState): HubState['language'] => state.hub.language;

export const getIsFileLoggerEnabled = (state: AppState): HubState['isFileLoggerEnabled'] =>
  state.hub.isFileLoggerEnabled;

export const getIsLabelPrinterResetting = (state: AppState): HubState['isLabelPrinterResetting'] =>
  state.hub.isLabelPrinterResetting;

export const getLogo = (state: AppState): HubState['logo'] => state.hub.logo;

export const getPrintSettings = (state: AppState): HubState['printSettings'] =>
  state.hub.printSettings;
